import { Injectable } from '@angular/core';
import { FabricService } from '../fabric/fabric.service';
import { Observable } from 'rxjs';

const SERVICE_NAME = 'metering-resources';

@Injectable({
  providedIn: 'root'
})
export class MetricsService {

  constructor(private fabricService: FabricService) { }

  getSystemHealth(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_health');
  }

  getServiceAvailability(params: any): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_availability', params);
  }
}
